import { AppCollectionDataTypes, baseMidwifeFields, FieldMap } from '@hb/shared'
import { insuranceProviderFields } from './insurer'

export const appCollectionFields: Partial<Record<keyof AppCollectionDataTypes, FieldMap>> = {
  insurers: insuranceProviderFields,
  medicaidInsurers: insuranceProviderFields,
  practices: baseMidwifeFields,
}
